import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/private/services/api.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ProjectService {

  constructor(private api: ApiService) { }

    getAllProject(data:any): Observable<any> {
    return this.api.post(environment.getAllProject,data);
    }
    createProject(data:any): Observable<any> {
    return this.api.post(environment.createProject,data);
    }
    updateProject(data:any): Observable<any> {
    return this.api.post(environment.updateProject,data);
    }
    deleteProject(data:any): Observable<any> {
    return this.api.post(environment.deleteProject,data);
    }
    getProjectById(data:any): Observable<any> {
    return this.api.post(environment.getProjectById,data);
    }
    getProjects(data:any): Observable<any> {
    return this.api.post(environment.getProjects,data);
    }
    getProjectMembers(data:any): Observable<any> {
    return this.api.post(environment.getProjectMembers,data);
    }

    /** Normalizes getProjectMembers API response to a flat user array. */
    parseProjectMembersResponse(res: any): any[] {
      if (!res) return [];

      let list: any[] = [];
      if (Array.isArray(res)) {
        list = res;
      } else if (Array.isArray(res?.data)) {
        list = res.data;
      } else if (Array.isArray(res?.rows)) {
        list = res.rows;
      }

      return list
        .map((item: any) => (item?.user ? item.user : item))
        .filter((user: any) => user?.user_id);
    }

    getProjectModuleList(data:any): Observable<any> {
      return this.api.post(environment.getProjectModuleList,data);
    }

    createProjectModule(data: any): Observable<any> {
      return this.api.post(environment.createProjectModule, data);
    }

    updateProjectModule(data: any): Observable<any> {
      return this.api.post(environment.updateProjectModule, data);
    }

    deleteProjectModule(data: any): Observable<any> {
      return this.api.post(environment.deleteProjectModule, data);
    }
}


